export class ClassNames{
    classNames:string[]
    constructor(initialClassNames:string[] = []){
        this.classNames = initialClassNames
    }
    toString(){
        return this.classNames.join(' ')
    }
    addClasses(classes:string[]){
        this.classNames = this.classNames.concat(classes)
    }
    addClass(className:string){
        this.classNames.push(className)
    }
}